// @ts-check
import React, { useState } from 'react';
import Uppy from '@uppy/core';
import { DashboardModal } from '@uppy/react';
import XHRUpload from '@uppy/xhr-upload';
import '@uppy/core/dist/style.css';
import '@uppy/dashboard/dist/style.css';
import { useEffect } from 'react';
import { useRef } from 'react';

/**
 * @component UppyDashboard
 * @author Hrithvik Gadhiya
 * @date July 20, 2023
 * @param { Object } props
 * @param { Object } props.metaData
 * @param { function } props.onSingleUploadSuccess
 * @param { function } props.onSingleUploadFailure
 * @param { boolean } props.open
 * @param { function } props.handleClose
 * @returns { JSX.Element }
 */

const UppyDashboard = ({
	metaData,
	onSingleUploadSuccess,
	onSingleUploadFailure,
	open,
	handleClose,
}) => {
	// Create a mutable ref that points to the current onSingleUploadSuccess function
	const onSingleUploadSuccessRef = useRef(onSingleUploadSuccess);

	// Update the ref each time onSingleUploadSuccess updates
	useEffect(() => {
		onSingleUploadSuccessRef.current = onSingleUploadSuccess;
	}, [onSingleUploadSuccess]);

	const [uppy] = useState(
		// const { CustomerId, CaseId, CommentId } = data;
		new Uppy({
			meta: metaData,
			restrictions: {},
		})
			// XHR
			.use(XHRUpload, {
				// endpoint: uploadUrl,
				endpoint: '/api2.0/canshare/upload',
				formData: true,
				fieldName: 'Files',
				timeout: 0,
			})
			.on('upload-success', (file, response) => {
				// console.log(file); // HTTP status code
				if (onSingleUploadSuccessRef.current) {
					onSingleUploadSuccessRef.current();
				} else if (onSingleUploadFailure) {
					// handle failure here
				}
			})
			.on('file-added', (file) => {}),
	);

	useEffect(() => {
		uppy.setMeta(metaData);
	}, [metaData]);

	// const handleClose = () => {
	// 	setOpen(false);
	// };

	const uppyProps = {
		uppy,
		// inline: true,
		showProgressDetails: true,
		// note: 'Unrestricted access for now',
		plugins: [],
		metaFields: [
			{
				id: 'name',
				name: 'Name',
				placeholder: 'File name (Include the extension)',
			},
			{
				id: 'description',
				name: 'Description',
				placeholder: 'Describe what the image is about',
			},
		],
	};

	return (
		<>
			<DashboardModal
				uppy={uppy}
				open={open}
				onRequestClose={() => {
					handleClose();
				}}
				closeModalOnClickOutside
				style={{ zIndex: 1201 }}
				proudlyDisplayPoweredByUppy={false}
				{...uppyProps}
			/>
		</>
	);
};

export default UppyDashboard;
